<template>
  <footer class="section-type-d pt-5 pb-5">
  <div class="modal fade" id="leasing" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="leasing">Leasing</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h5>¿Qué es?</h5>
          <blockquote class="blockquote">
            <p class="mb-0">
              Leasing. En un esquema de arrendamiento puro sin importar tu actividad o giro, con las rentas mensuales más competitivas del mercado. Puedes estrenar un Chevrolet® con tres sencillos pasos: Elige el vehículo y estrénalo sin necesidad de dar enganche.
            </p>
          </blockquote>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="garantia" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Garantía Plus®</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h5>¿Qué es?</h5>
          <blockquote class="blockquote">
            <p class="mb-0">
              Tu vehículo Chevrolet® cuenta con una garantía de fábrica de 3 años o hasta 60,000km, en la que se cubre la reparación de aquellos desperfectos mecánicos o eléctricos inesperados. Cuida tu inversión con GM Garantía Plus® que es la garantía extendida que amplía la cobertura antes mencionada a una cobertura de hasta por 6 años ó 120,000 km.
            </p>
          </blockquote>

          <h5>¿Cómo funciona?</h5>
          <blockquote class="blockquote">
            <p class="mb-0">
              Cubre la reparación o sustitución de los elementos del vehículo que cuenten con alguna falla mecánica o eléctrica. A continuación, te presentamos algunos ejemplos de los elementos cubiertos, los cuales pueden variar por modelo o tipo de vehículo.
            </p>
          </blockquote>

            <h5>¿Qué beneficios brinda GM Garantía Plus® ?</h5>
          <blockquote class="blockquote">
            <p class="mb-0">
              Protección a su economía ante posibles imprevistos referentes al sistema mecánico o eléctrico de su vehículo.
            </p>
          </blockquote>

           <blockquote class="blockquote">
            <p class="mb-0">
              Mayor valor de reventa del automóvil ya que brinda la posibilidad de ceder beneficios de cobertura a un nuevo propietario.
            </p>
          </blockquote>

          <blockquote class="blockquote">
            <p class="mb-0">
              Te brinda protección y seguridad adicional con asistencia.
            </p>
          </blockquote>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="financiamientos" data-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="financiamientos">Tenemos un plan a la medidade tus necesidades.</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <h3>Flex Pay</h3>
              <p>Es un plan de financiamiento para estrenar un Chevrolet® con esquema de mensualidades bajas a través de GM Financial. Chevrolet® te ofrece estrenar el auto que desees con estos simples pasos:</p>
            </div>
             <div class="col-md-12">
              <h3>Leasing</h3>
              <p>En un esquema de arrendamiento puro sin importar tu actividad o giro, con las rentas mensuales más competitivas del mercado. Puedes estrenar un Chevrolet® con tres sencillos pasos:</p>
            </div>
             <div class="col-md-12">
              <h3>Financiamiento</h3>
              <p>En Chevrolet Servicios Financieros tenemos los mejores planes de financiamiento hechos a tu medida; obtén precios especiales con distintas opciones de pago para que estrenes tu Chevrolet® favorito.</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="contacto" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">CONTÁCTANOS</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
         <div class="container">
          <div class="row">
            <div class="col-md-12">
                <div class="well well-sm">
                    <form class="form-horizontal" method="post">
                        <fieldset>
                            <div class="form-group">
                                <div class="col-md-12">
                                    <input id="fname" name="name" type="text" placeholder="NOMBRE" class="form-control">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-12">
                                    <input id="lname" name="name" type="text" placeholder="APELLIDO PATERNO" class="form-control">
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-md-12">
                                    <input id="email" name="email" type="text" placeholder="CONFIRMAR CORREO ELECTRÓNICO *" class="form-control">
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-md-12">
                                    <input id="phone" name="phone" type="text" placeholder="NÚMERO TELÉFONO *" class="form-control">
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-md-12">
                                    <textarea class="form-control" id="message" name="message" placeholder="DATOS/COMENTARIOS" rows="7"></textarea>
                                </div>
                            </div>
                            <div class="overflow-auto"  style="height: 159px;">AVISO DE PRIVACIDAD SIMPLIFICADO VIGENTE A PARTIR DEL 1 DE SEPTIEMBRE DE 2017 General Motors de México S. de R.L. de C.V. (GMM) con domicilio en Ejército Nacional No. 843-B, Col. Granada, Del. Miguel Hidalgo, C.P. 11520, México, D.F., recaba sus datos personales para identificarle, contactarle, dar cumplimiento a las obligaciones contraídas con GMM; evaluar la calidad de los servicios que le ofrecemos y responder a sus comentarios o solicitudes de información. Para conocer nuestro Aviso de Privacidad Integral visite http://www.gm.com.mx/. Si usted no desea que GMM trate su información para alguna de las mencionadas finalidades, desde este momento usted nos puede comunicar lo anterior al correo protecciondedatos@gm.com y ponemos a su disposición un mecanismo habilitado en el Centro de Atención al Clientes de GMM en su teléfono: 800-508-0000 para ejercer sus derechos de acceso, rectificación, cancelación y oposición. *</div>
                             <div class="form-group">
                                <div class="col-md-12 text-center">
                                    <button type="submit" class="btn btn-primary btn-lg">Enviar solicitud</button>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
          </div>
         </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="Privacidad" data-backdrop="static" data-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">AVISO DE PRIVACIDAD INTEGRAL</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
         AVISO DE PRIVACIDAD INTEGRAL GMM
        (Vigente a partir del 1 de Noviembre del 2019)
        ¿Quién dará tratamiento a tus datos personales?
        Los datos personales proporcionados por usted serán utilizados por General Motors de México S. de R.L. de C.V. (GMM) con domicilio en Ejército Nacional No. 843-B, Col. Granada, Del. Miguel Hidalgo, C.P. 11520, México, D.F.
        ¿Qué información vamos a recabar?
        GMM para cumplir con las finalidades señaladas en el presente Aviso tratará datos personales de identificación, incluyendo el Número de Identificación del Vehículo (“VIN” por sus siglas en inglés), datos personales de contacto, datos personales fiscales y datos personales patrimoniales y/o financieros. En el supuesto de que usted nos contacte por redes sociales, podremos dar tratamiento a la información contenida en su perfil público de la red social de que se trate, así como al contenido de sus publicaciones.
        Le informamos que para efectos de lo señalado en el presente aviso de privacidad GMM no tratará datos personales sensibles.
        ¿Para qué fines usamos tu información?
        Los datos personales que nos ha proporcionado serán utilizados para las siguientes actividades primarias y necesarias: (i) identificarle; (ii) contactarle; (iii) dar seguimiento, actualización y confirmación en cuanto a productos y servicios contratados; (iv) para darle servicios a través de nuestro Call Center; (v) Proveerle del bien y/o servicio que solicite, (vi) Honrar la garantía de su vehículo o de las partes, refacciones y refacciones, (vii) Informarle acerca de llamados a revisión de su vehículo y brindarle servicios de asistencia técnica, (viii) Mantener actualizados nuestros registros a fin de poder responderle a sus consultas; (ix) evaluar la calidad de los servicios que le ofrecemos; (x) responder a sus comentarios o solicitudes de información.
        ¿Qué otros usos podemos darle a tu información?
        De manera adicional, si usted no se opone, GMM utilizará su información personal para el envío tanto físico como electrónico, de publicidad y comunicación con fines de mercadotecnia y telemarketing, y para la prospección comercial y análisis estadísticos y de mercado, así como para invitarle a participar en encuestas de calidad del servicio y a eventos organizados por GMM.
        En caso de que no desee que sus datos personales sean tratados para alguna o todas las finalidades adicionales, desde este momento usted nos puede comunicar lo anterior a la dirección: protecciondedatos@gm.com
        ¿A qué terceros podemos transferir tu información?
        GMM para cumplir las finalidades necesarias anteriormente descritas u otras aquellas exigidas legalmente o por las autoridades competentes, podrá transferir los datos personales a:
        (i)   Autoridades laborales y/ o a otras  autoridades competentes para dar cumplimiento a disposiciones legales;
        (ii)  A empresas matrices, subsidiarias y/o filiales de GMM;
        (iii) A GM Financial y a otros terceros con los cuales tenga convenios escritos de transferencia de datos los cuales operan bajo políticas de privacidad que cumplen con las disposiciones aplicables correspondientes para alguna de las finalidades señaladas en el presente aviso de privacidad;
        (iv) A instituciones bancarias para realizar  pagos; y;
        (v)  A autoridades competentes en los casos legalmente previstos.
        Para el efecto, le informamos que el consentimiento para la transferencia de sus datos personales no es requerido.
        ¿Cómo puedes ejercer tus derechos ARCO y/o revocar tu consentimiento?
        Usted o su representante legal podrá ejercer cualquiera de los derechos de acceso, rectificación, cancelación u oposición (en lo sucesivo “derechos Arco”), así como revocar su consentimiento para el tratamiento de sus datos personales enviando un correo electrónico, al Departamento de Protección de Datos Personales de GMM a la dirección protecciondedatos@gm.com.
        Su petición deberá ser realizada a través del Formato de Solicitud de Derechos ARCO, el cual debe ser solicitado a la dirección de correo electrónico antes señalada. Para que el Departamento de Protección de Datos Personales de GMM pueda darle seguimiento a su solicitud, usted o su representante legal, deberá acreditar correctamente su identidad para lo que es necesario que complete todos los campos indicados en el Formato y lo acompañe con copia de alguna de las identificaciones oficiales vigentes que se señalan en el mismo. Para  mayor información sobre los procedimientos, requisitos y plazos para el ejercicio de sus Derechos ARCO y/o revocación del consentimiento contacte al Departamento de Protección de Datos Personales de GMM al correo protecciondedatos@gm.com.
        ¿Cómo puedes limitar el uso y/o divulgación de tus datos?
        Usted podrá limitar el uso o divulgación de sus datos personales enviando su solicitud a la dirección: protecciondedatos@gm.com. En caso de que su Solicitud sea procedente se le registrará en el listado de exclusión propio de GMM.  Para mayor información favor de contactar a nuestro Departamento de Protección de Datos Personales de GMM.
        ¿Cómo te notificaremos de los cambios que efectuemos al presente Aviso de Privacidad?
        GMM le notificará de cualquier cambio a su aviso de privacidad a través de nuestra página de internet: http://www.gm.com.mx, por lo cual le pedimos revise la misma de manera periódica.
        ¿Cómo puedes hacernos llegar tus dudas?
        Nuestro Departamento de Protección de Datos Personales queda a sus órdenes para proporcionarle cualquier información adicional que requiera o, en su caso, para resolver cualquier duda que pudiera surgirle en materia de privacidad y protección de datos personales, para lo que podrá contactarnos a través del correo electrónico protecciondedatos@gm.com.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

   <div class="modal fade" id="terminos" data-backdrop="static" data-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">TÉRMINOS Y CONDICIONES</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          El presente documento tiene por objeto el regular el uso de este sitio de Internet (en adelante denominado como «www.chevrolet-excelencia.com»), que las sociedades Excelencia Automotriz S.A. de C.V., Excelencia Automotriz del Norte S.A. de C.V. y Excelencia Automotriz de Hidalgo S.A. de C.V., (en lo sucesivo «Las Distribuidoras CHEVROLET»), ponen a disposición del público en general en la URL www.chevrolet-excelencia.com. La sola utilización del Sitio le otorga la calidad de usuario (en adelante referido como el «Usuario»), y supone su aceptación plena e incondicional, de todas y cada una de las condiciones generales y particulares incluidas en el presente Aviso Legal
        “Las Distribuidoras CHEVROLET” pueden ofrecer a través del Sitio bienes y/o servicios que podrán someterse a condiciones particulares, informándole al Usuario en cada caso en concreto. El contenido de los vehículos publicados son estrictamente ilustrativos e informativos, todos los términos condiciones, colores, características, equipamiento, materiales, especificaciones técnicas y/o refacciones de los vehículos aquí mostrados podrán cambiar sin previo aviso, y sin incurrir en responsabilidad por parte de “Las Distribuidoras CHEVROLET”.

        “Las Distribuidoras CHEVROLET” no ofrecen garantía respecto de la exactitud y veracidad de la información contenida en el Sitio, o que por error y omisión sea incorrecta. Con el objetivo de minimizar los inconvenientes ocasionados al Usuario, se le recomienda que la utilización del Sitio sea exclusivamente con fines orientativos.

        MODIFICACIONES

        “Las Distribuidoras CHEVROLET” podrán realizar modificaciones a los TÉRMINOS Y CONDICIONES DE USO de este Sitio en cualquier momento que lo considere apropiado, siendo exclusiva responsabilidad del usuario asegurarse de tomar conocimiento de tales modificaciones.

        USO ADECUADO DEL SITIO

        El usuario tendrá derecho de hacer uso de los contenidos del Sitio de conformidad con los TÉRMINOS Y CONDICIONES DE USO que aquí se establecen, entendiéndose por “contenidos” a: (i) todos los bienes o servicios que ofrezcan “Las Distribuidoras CHEVROLET” al usuario, a través del Sitio, y (ii) toda la información contenida en el Sitio, incluyendo cualquier texto, programas, fotografías, imágenes y multimedia.

        El Usuario se compromete a utilizar el Sitio de conformidad con el presente Aviso Legal, las Leyes de los Estados Unidos Mexicanos, la legislación vigente en el país que el Usuario se encuentre al momento de usarlo, las buenas costumbres, el orden público y los derechos de terceros. Del mismo modo el Usuario se obliga a no utilizar el Sitio o los servicios que se prestan en éste, con fines ilícitos o contrarios al presente Aviso Legal, lesivos de los intereses o derechos de terceros, o que de cualquier forma pueda dañar, inutilizar o deteriorar el Sitio o sus servicios, o impedir un normal disfrute del Sitio a otros Usuarios.

        El Sitio es de uso personal para el Usuario, por lo que no podrá comercializar de manera alguna los bienes o servicios contenidos.

        PROPIEDAD INDUSTRIAL y/o INTELECTUAL

        Todas las marcas, nombres comerciales, signos distintivos, logotipos y cualquier otro elemento para distinguir a los bienes o servicios (siluetas, imágenes, textos, ilustraciones, fotografías, lemas, videos, etc.) que se encuentren contenidos actualmente o se inserten en un futuro en el Sitio, son propiedad exclusiva de “Las Distribuidoras CHEVROLET”, sus empresas filiales y/o subsidiarias o pertenecientes a su mismo grupo comercial, por lo que está prohibida su reproducción, modificación, trasmisión, distribución, comercialización, o transformación parcial o total, así como cualquier otro uso del contenido de este Sitio en alguna otra página de Internet o publicación, constituyendo el incumplimiento a esta disposición una infracción de los derechos de propiedad intelectual y/o industrial de “Las Distribuidoras CHEVROLET” o del titular de los mismos.

        RESPONSABILIDAD DEL USUARIO

        El Usuario es el único responsable de las infracciones en las que pudiera incurrir o de los daños que pudiera ocasionar por el mal uso del Sitio, así como de cualquier acción o reclamación legal, judicial o extrajudicial iniciada por terceras personas en contra de “Las Distribuidoras CHEVROLET”, por lo que, en su caso, el Usuario se obliga a asumir todos los gastos, costas e indemnizaciones irrogados a “Las Distribuidoras CHEVROLET” con

        motivo de tales reclamaciones o acciones legales.

        INTROMISIÓN DE TERCEROS AL SITIO

        “Las Distribuidoras CHEVROLET” quedan exoneradas de cualquier clase de responsabilidad que se pudiera derivar de interrupciones, retrasos, virus informáticos, sobre carga en líneas telefónicas, en Internet o desconexiones en el funcionamiento del Sitio, motivado por causas ajenas a “Las

        Distribuidoras CHEVROLET”, así como de daños y/o intromisiones ilegitimas causados por terceras personas al Sitio, mencionando de forma enunciativa pero no limitativa: suplantación en el contenido, secuencia de comandos en sitios cruzados (cross-site scripting), desbordamiento de búfer, ataques de formato de cadena, comandos de sistema operativo, inyección de código SQL, inyección de código SSI, inyección XPath, indexación de directorio, fuga de información, directorio transversal (path traversal), localización de recursos predecibles, abuso de funcionalidad, denegación de servicio, anti-automatización insuficiente, validación de proceso insuficiente y todos sus derivados, además de amenazas futuras.

        PRIVACIDAD DE LA INFORMACIÓN

        “Las Distribuidoras CHEVROLET” pondrán a disposición del Usuario en el Sitio «Los Avisos de Privacidad», los cuales se recomienda consultar para información referente al tratamiento de sus datos personales. “Las Distribuidoras CHEVROLET” se reservan el derecho de modificar en cualquier momento sus Avisos de Privacidad, anunciando al Usuario de dichas modificaciones en el Sitio.

        COOKIES

        El usuario que tenga acceso al Sitio, acuerda recibir las cookies que les transmitan los servidores de “Las Distribuidoras CHEVROLET”. Se entiende por "Cookie" a los archivos de datos que se generan en el ordenador del Usuario cuando ingresa al Sitio. Las Cookies pueden contener información tal como (i) la identificación proporcionada por el usuario, (ii) información para rastrear las páginas que el usuario ha visitado, (iii) fecha y hora en la cual el Usuario visitó por última vez el Sitio y, (iii) otros datos.

        El Usuario tendrá la opción de impedir la generación de cookies en cualquier momento, en la barra de opciones de Internet de su navegador.

        SEGURIDAD DEL SITIO

        “Las Distribuidoras CHEVROLET” garantizan la seguridad de la información que se transmite entre el Usuario y el Sitio. La seguridad de la información que se transmite entre el Usuario y las páginas de terceros enlazados al Sitio será responsabilidad exclusiva de dichos terceros y del

        Usuario.

        LEGISLACIÓN APLICABLE

        Para todo lo relacionado con la interpretación, cumplimiento y ejecución del presente Aviso Legal, las partes están de acuerdo en someterse a las

        Leyes y Tribunales competentes de la Ciudad de México, Distrito Federal, renunciando expresamente a cualquier otro fuero o jurisdicción que pudiera corresponderles en razón de sus domicilios presentes o futuros.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

   <div class="modal fade" id="fleetServices"  role="dialog" data-backdrop="static" data-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Chevrolet Fleet Services</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h5>BENEFICIOS PARA TU FLOTILLA</h5>
          <blockquote class="blockquote">
            <p class="mb-0">
              Chevrolet Fleet Services que te permite llevar una mejor administración de los servicios y gastos de mantenimiento de tu flotilla, con las siguientes ventajas:
            </p>
            <br/>
            <div class="mb-4">
              <ul>
                <li>Descuento por volumen.</li>
                <li>Entregas a nivel nacional, sin cargo extra.</li>
                <li>Precios negociados y estandarizados a nivel nacional a través de cualquier distribuidor Chevrolet.</li>
                <li>Control de entradas, salidas y tiempo de mantenimiento.</li>
                <li>Programa de Facturación Electrónica Centralizada (FEC).</li>
                <li>Facturación al cierre de cada mes.</li>
                <li>Un mes de crédito para liquidar los servicios.</li>
                <li>Mejor administración y consulta del historial de servicios de tu flotilla.</li>
                <li>Contamos con la mayor infraestructura y equipo de soporte a nivel nacional.</li>
                <li>Accesorización en Patios.</li>
                <li>Servicios de asistencia personalizada OnStar<sup>®</sup>.<br> </li>
                <li>Ofrecemos planes únicos para tu flotilla.</li>
              </ul>
            </div>
          </blockquote>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
   </div>

   <div class="modal fade" id="tallerServicio" role="dialog" data-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">taller de servicio</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h5>¿Qué es?</h5>
          <blockquote class="blockquote">
            <p class="mb-0">
              Con nuestro compromiso de Servicio Preferencial, Facturación Electrónica Centralizada, OnStar® y Beneficios Adicionales para tus empleados, elegir el servicio de flotillas Chevrolet Fleet Services, es una buena decisión que se multiplica todos los días.
            </p>
          </blockquote>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
   </div>

    <div class="personal-container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-6 col-lg-2">
          <img src="@/assets/images/logo/logo2.png" class="w-100 d-block mx-auto" style="max-width: 150px;" alt="Agencia Felix">
          <div class="d-flex justify-content-around mt-2">
            <a href="https://www.facebook.com/grupofelixmx/" target="_blank">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.instagram.com/grupofelixmx/" target="_blank">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="https://twitter.com/GrupoFelixMX" target="_blank">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="https://www.linkedin.com/company/grupof%C3%A9lix-automotriz/" target="_blank">
              <i class="fab fa-linkedin-in"></i>
            </a>
            <a href="https://www.youtube.com/channel/UCveyNZD8gJ_4rRWVexuDYVg" target="_blank">
              <i class="fab fa-youtube"></i>
            </a>
          </div>
        </div>

        <div class="col-6 col-lg-2">
          <h5 class="font-weight-bold mb-24" >Inventario</h5>
          <p class="mb-16 option-selectable" > <a href="/autosnuevoschevrolet">Nuevos</a></p>
          <p class="mb-16 option-selectable"> <a href="/autosseminuevoschevrolet">Seminuevos</a></p>
          <p class="mb-16 option-selectable" data-toggle="modal" data-target="#fleetServices"><a>Fleet Services</a></p>
          <p class="mb-16 option-selectable" ><a href="/financiamiento">Financiamientos</a></p></div>
        <div class="col-6 col-lg-2">
          <h5 class="font-weight-bold mb-24" data-bs-toggle="modal" data-bs-target="#exampleModalLong">Servicios Postventa</h5>
          <p class="mb-16 option-selectable" data-toggle="modal"  data-target="#tallerServicio"><a href="/servicio-certificado">Taller de Servicio</a></p>
          <p class="mb-16 option-selectable" data-toggle="modal"  data-target="#exampleModalLong"><a href="/Colision">Taller de Colisión</a></p>
        </div>
        <div class="col-6 col-lg-2">
          <h5 class="font-weight-bold mb-24">Financiamiento</h5>
          <p class="mb-16 option-selectable"> <a href="/solicitud-creditoL">Solicitud de Crédito</a></p>
          <p class="mb-16 option-selectable" data-toggle="modal" data-target="#garantia">Garantía</p>
        </div>
        <div class="col-6 col-lg-2">
          <h5 class="font-weight-bold mb-24">Nosotros</h5>
          <p class="mb-16 option-selectable"><a href="/nosotros">Quiénes Somos</a></p>
          <p class="mb-16 option-selectable" data-toggle="modal" data-target="#Privacidad">Aviso de Privacidad</p>

          <p class="mb-16 option-selectable" data-toggle="modal" data-target="#terminos">Términos y Condiciones</p>
          <p class="mb-16 option-selectable" data-bs-toggle="modal" data-target="#contacto"> <a href="/contacto">Contáctanos</a></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>

</style>
